import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataTransform } from 'app/models/data-transform';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  static getUrlPathname<T>(req: HttpRequest<T>) {
    return /^https?:\/\//.test(req.url) ? new URL(req.url).pathname : req.url;
  }

  static isPostOrPut<T>(req: HttpRequest<T>) {
    return req.method === 'POST' || req.method === 'PUT';
  }

  static isDeleteOrIgnore<T>(req: HttpRequest<T>, regexp: RegExp) {
    let pathname: string = RequestService.getUrlPathname(req);
    return req.method === 'DELETE' || !regexp.test(pathname) || pathname.endsWith('/token');
  }

  static getReqTransformPost<T>(req: HttpRequest<T>, transformDown: DataTransform) {
    const bodyCopy = structuredClone(req.body);
    return req.clone({
      body: transformDown.transform(bodyCopy),
    });
  }

  static getReqTransformGet<T>(event: HttpEvent<T>, transformUp: DataTransform) {
    if (event instanceof HttpResponse && event.status !== 204) {
      return event.clone({
        body: transformUp.transform(event.body),
      });
    }
    return event;
  }

  static getTransformedHttpEvent<T>(
    req: HttpRequest<T>,
    next: HttpHandler,
    _rexp: RegExp,
    transformDown: DataTransform,
    transformUp: DataTransform,
  ) {
    if (RequestService.isDeleteOrIgnore(req, _rexp)) {
      return next.handle(req);
    }

    if (RequestService.isPostOrPut(req)) {
      req = RequestService.getReqTransformPost(req, transformDown);
    }

    return next.handle(req).pipe(
      map((event: HttpEvent<T>) => {
        return RequestService.getReqTransformGet(event, transformUp);
      }),
    );
  }
}
